<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <div v-if="xsucursal" class="my-2 mx-2">
        <p class="mb-0"><b> Cod. Sucursal: </b> {{ xsucursal.numero_sucursal }}</p>
        <p class="mb-0"><b>Direccion:</b> {{ xsucursal.direccion }}</p>
      </div>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Puntos de venta </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn :disabled="loading || desserts.length > 1000" class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-plus
              </v-icon>
              {{ desserts.length > 1000 ? 'No se permite mas de 1000 punto' : 'Agregar' }}
            </v-btn>

            <v-btn :disabled="loading" class="ml-2 orange" dark @click="sincronizarPuntos()">
              <v-icon small>
                mdi-plus
              </v-icon>
              Sincronizar puntos
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.nombre`]="{ item }">
          <span> {{ item.nombre }} </span>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="red" class="darken-4 mr-4" dark v-bind="attrs" v-on="on" @click="preeliminar(item)">
                mdi-delete
              </v-icon>
            </template>
            <span> Cerrar punto de venta </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                class="darken-4 mr-4"
                dark
                small
                v-bind="attrs"
                v-on="on"
                @click="abrircufds(item.codigo_punto_venta)"
              >
                mdi-credit-card-marker-outline
              </v-icon>
            </template>
            <span> Registrar Cufd </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                class="darken-4 mr-2"
                dark
                small
                v-bind="attrs"
                v-on="on"
                @click="abrirevento(item.codigo_punto_venta)"
              >
                mdi-bullhorn
              </v-icon>
            </template>
            <span> Ver Ev. Significativos </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="green" class="darken-4" dark small v-bind="attrs" v-on="on" @click="solicitarcuis(item)">
                mdi-gesture-tap
              </v-icon>
            </template>
            <span> Solicitar Cuis </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </template>

    <PuntoReg ref="puntoreg" v-on:newregpunto="newregpunto" />
    <EventosReg ref="eventosreg" v-on:newregevento="newregevento" />
  </div>
</template>

<script>
  import { getAccessToken } from '@/accessToken';
  import PuntoReg from '@/views/recibos/pventas/registrar.vue';
  import EventosReg from '@/views/recibos/esignificativos/registrar.vue';
  import xaxios from '@/xaxios';
  import axios from 'axios';
  
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      xsucursal: null,
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        //{ text: 'Estado Facturacion', value: 'estado_facturacion' },
        { text: 'Codigo Punto Venta', value: 'codigo_punto_venta' },
        //{ text: 'Tipo Punto Venta', value: 'tipo_punto_venta' },
        // { text: 'Sucursal ID', value: 'sucursal_id' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 150 },
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      apikeytoken: null,
    }),

    components: { PuntoReg, EventosReg },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        let idsucursal = this.$route.query.idsucursal;
        this.xsucursal = null;
        this.getsucursal(idsucursal);
        vue.loading = true;
        var config = {
          method: 'get',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas`,
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas?sucursalId=${idsucursal}`,
          headers: {
            //apikey: '4265269017',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.sort((a, b) => {
              let f = 0;
              if (a.codigo_punto_venta > b.codigo_punto_venta) f = 1;
              else if (a.codigo_punto_venta < b.codigo_punto_venta) f = -1;
              return f;
            });
            vue.desserts = data;
            vue.loading = false;
            window.console.log(vue.desserts);
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      getsucursal(idsucursal) {
        this.obtenerToknFactura();
        const vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsucursal}`,
          headers: {
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            vue.xsucursal = response.data;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },

      abrircufds(codigoPuntoVenta) {
        let idsucursal = this.$route.query.idsucursal;
        let numsucursal = this.$route.query.numsucursal;
        let urls = `/cufds?codigopunto=${codigoPuntoVenta}&codsucursal=${numsucursal}&idsucursal=${idsucursal}`;
        this.$router.push(urls);
      },

      abrirevento(codigoPuntoVenta) {
        /*let data = {
          codigoPuntoVenta: codigoPuntoVenta,
          codigoSucursal: parseInt(this.$route.query.numsucursal),
        };

        this.$refs.eventosreg.openmodal(null, data);*/
        let numsucursal = this.$route.query.numsucursal;
        let idsucursal = this.$route.query.idsucursal;
        let urls = `/eventosbypuntos?idsucursal=${idsucursal}&numsucursal=${numsucursal}&codigopunto=${codigoPuntoVenta}`;
        this.$router.push(urls);
      },

      newregpunto() {
        /*let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.descripcion = item.descripcion;
          e.estado = item.estado;
          e.nombre = item.nombre;
          e.sucursalId = item.sucursalId;
          e.tipoPuntoVenta = item.tipoPuntoVenta;
        } else {*/
        this.initialize();
        //}
      },
      newregevento() {},

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        let idsucursal = this.$route.query.idsucursal;
        let numsucursal = this.$route.query.numsucursal;
        this.$refs.puntoreg.openmodal(item, idsucursal, numsucursal, this.xsucursal);
      },

      preeliminar(item) {
        window.console.log(item);
        let vue = this;
        let opt = {
          verification: 'eliminar',
          verificationHelp: 'Escriba "[+:verification]" para eliminar el punto de venta.',
          okText: 'Eliminar Punto',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'hard',
        };
        var message = {
          title: 'Confirmar eliminacion',
          body: '<br> <b>NOTA:</b> Esta accion es ireeversible.',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.deleteItem(item, dialog);
          })
          .catch(function() {});
      },
      deleteItem(item, dialog) {
        var config = {
          method: 'delete',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/puntosventas/${item.id}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.apikeytoken,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log(data);
            dialog.close();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
          });
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      sincronizarPuntos() {
        let vue = this;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Hora.',
          okText: 'Sincronizar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Sincronizacion',
          body: '<br> <b>NOTA:</b> .',
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.finalizarItem(dialog);
          })
          .catch(function() {});
      },
      finalizarItem(dialog) {
        let vue = this;
        let idsucursal = this.$route.query.idsucursal;
        let numsucursal = this.$route.query.numsucursal;
        let data = {
          sucursal_id: parseInt(idsucursal),
          codigo_sucursal: parseInt(numsucursal),
          nit: '4265269017',
        };
        if (this.xsucursal && this.xsucursal.nit) {
          data.nit = this.xsucursal.nit;
        }
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/puntosventas/sincronizar`,
          headers: {
            'Content-Type': 'application/json',
            //apikey: '4265269017',
          },
          data: data,
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response.data);
            dialog.close();
            vue.$root.$notify.show(response.data.data, { color: 'success' });
            vue.initialize();
          })
          .catch(function(error) {
            window.console.log(error.response);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },

      solicitarcuis(item) {
        //window.console.log(item);
        let vue = this;
        let codigoPuntoVenta = item.codigo_punto_venta;
        let codigoSucursal = item.sucursal.numero_sucursal;
        let opt = {
          verification: 'si',
          verificationHelp: 'Escriba "[+:verification]" para Sincronizar Catalogo.',
          okText: 'Solicitar',
          cancelText: 'cancelar',
          backdropClose: false,
          animation: 'bounce',
          loader: true,
          type: 'classic',
        };
        var message = {
          title: 'Confirmar Solicitud de CUIS',
          body: `<br> Codigo Unico de Inicio de Sistema:<br> <b>Codigo Sucursal:</b> ${codigoSucursal} <br> <b>Codigo Punto:</b> ${codigoPuntoVenta}`,
        };
        this.$dialog
          .confirm(message, opt)
          .then(function(dialog) {
            vue.iniciarSolictudCuis(item, dialog);
          })
          .catch(function() {});
      },
      iniciarSolictudCuis(item, dialog) {
        let vue = this;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cuis`,
          headers: {
            'Content-Type': 'application/json',
            apikey: this.apikeytoken,
          },
          data: {
            codigoPuntoVenta: item.codigo_punto_venta,
            codigoSucursal: item.sucursal.numero_sucursal,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            window.console.log(response.data);
            let data = response.data;
            if (data) {
              let ms = `Codigo: ${data.codigo}, Vigencia: ${data.fechaVigencia}`;
              vue.$root.$notify.show(ms, { color: 'success' });
            } else {
              vue.$root.$notify.show('Error al solicitar cuis', { color: 'red' });
            }
            dialog.close();
          })
          .catch(function(error) {
            window.console.log(error);
            dialog.close();
            vue.$root.$notify.show('Error', { color: 'red' });
          });
      },
      async obtenerToknFactura() {
        let idsuc = this.$route.query.idsucursal;
        let tok = getAccessToken();
        const apiAxios = axios.create({
          baseURL: '',
          headers: {
            'Content-Type': 'application/json',
            Authorization: tok,
          },
        });
        this.apikeytoken = await apiAxios
          .get(`${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales/${idsuc}`)
          .then(({ data }) => (data.apikey ? data.apikey : ''));
      },
    },
  };
</script>
